import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';

import { AppTypes, AuthTypes } from 'config/global-enums';
import { authenticationFormSaga } from './saga';
import { createSlice } from 'utils/@reduxjs/toolkit';
import {
  sliceLoadStart,
  sliceSpecialLoadFail,
  sliceSpecialLoadHandle,
} from 'utils/tools/slice-actions';

export const initialState = {
  loading: false,
  authType: AuthTypes.LOGIN,
  userLoginType: AppTypes.CUSTOMER,
  authLoading: true,
  error: null,
  authData: [],
  phoneError: null,
  isAuthenticated: false,
  isRegistered: false,
  isUserVerified: false,
  formSubmitted: null,
  userDetails: null,
  officeDetails: null,
  originalOfficeId: null,
  firstRegistration: false,
  demoOrgDetails: false,
  regPrefilledValues: null,
  firstRegCompleted: false,
  userType: 'employee',

  chatWidgetQueryParams: null,

  hideForOzone: true,
};

export const AuthenticationActionTypes = {
  FETCH_ORGANISATION_TECH_LIST: 'fetchOrganisationTechList',
};

const newFormLoad = state => {
  state.formSubmitted = false;
  sliceLoadStart(state);
};

const slice = createSlice({
  name: 'authenticationForm',
  initialState,
  reducers: {
    toggleAuthType(state, action) {
      state.authType = action?.payload?.authType;
    },
    toggleUserLoginType(state, action) {
      state.userLoginType = action?.payload?.userLoginType;
    },
    setRegPrefilledValues(state, action) {
      state.regPrefilledValues = action?.payload?.regPrefilledValues;
    },
    authPhoneStart(state) {
      state.phoneError = null;
      state.authLoading = true;
    },
    authPhoneEnd(state) {
      state.authLoading = false;
    },
    verifyOtpStart(state) {
      state.error = null;
      state.authLoading = true;
    },
    verifyOtpEnd(state) {
      state.isAuthenticated = true;
    },
    verifySocialLoginStart(state) {
      state.error = null;
      state.authLoading = true;
    },
    verifySocialLoginEnd(state) {
      state.isAuthenticated = true;
    },
    registerPersonal(state) {
      newFormLoad(state);
    },
    manageCustomerOganisationStart(state) {
      newFormLoad(state);
    },
    registerOrganisationStart(state) {
      newFormLoad(state);
    },
    fetchProfileStart(state) {
      newFormLoad(state);
    },
    toggleFirstRegistration(state, action) {
      state.firstRegistration = action?.payload;
    },
    toggleFirstRegCompleted(state, action) {
      state.firstRegCompleted = action?.payload;
    },
    registerProfile(state, action) {
      const profileValues = action?.payload;

      state.loading = false;
      state.authLoading = false;
      state.isAuthenticated = true;
      state.userDetails = profileValues;
      state.isRegistered = !!(
        profileValues?.first_name &&
        (profileValues?.organisation_offices?.length ||
          profileValues?.citizen_organisation_offices?.length)
      );
      // state.isRegistered = !!(
      //   (profileValues?.crm_contact_list?.length > 0 &&
      //     profileValues?.crm_contact_list[0]?.organisation_office_id) ||
      //   (profileValues?.first_name &&
      //     (profileValues?.organisation_offices?.length ||
      //       profileValues?.citizen_organisation_offices?.length))
      // );
      state.isUserVerified = profileValues?.is_user_verified;
      state.demoOrgDetails = profileValues?.demo_organisation_details;
      state.userType = profileValues?.user_type;
    },
    formSubmitSuccess(state) {
      state.formSubmitted = true;
      state.loading = false;
    },
    logoutStart(state) {
      state.error = null;
      state.authLoading = true;
    },
    logoutEnd(state) {
      Object.keys(initialState).forEach(el => (state[el] = initialState[el]));
      state.authLoading = false;
    },
    phoneNumberError(state) {
      state.phoneError = true;
      state.authLoading = false;
    },
    authError(state, action) {
      state.error = action.payload;
      state.authLoading = false;
      state.loading = false;
    },
    setUserOffice(state, action) {
      state.loading = false;
      state.officeDetails = action.payload;
    },
    setOriginalOfficeId(state, action) {
      state.loading = false;
      state.originalOfficeId = action.payload;
    },
    fetchOrganisationTechListStart(state) {
      sliceSpecialLoadHandle(
        state,
        AuthenticationActionTypes.FETCH_ORGANISATION_TECH_LIST,
        true,
      );
    },
    fetchPageActionStart(state, action) {
      sliceSpecialLoadHandle(state, action, true);
    },
    fetchPageActionEnd(state, action) {
      const { actionFor, data, page_number, page_size, total } = action.payload;
      sliceSpecialLoadHandle(
        state,
        actionFor,
        false,
        data,
        page_number,
        page_size,
        total,
      );
    },
    fetchPageActionError(state, action) {
      const { actionFor, error } = action.payload;
      sliceSpecialLoadFail(state, actionFor, error);
    },
    toggleHideForOzone(state, action) {
      state.hideForOzone = action?.payload;
    },
    setChatWidgetQueryParams(state, action) {
      state.chatWidgetQueryParams = action?.payload;
    },
  },
});

export const { actions: authenticationFormActions, reducer } = slice;

export const useAuthenticationFormSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: authenticationFormSaga });
  return { actions: slice.actions };
};
